import { useQuery } from '@tanstack/react-query';
import { authApi } from 'auth/auth.api';
import { queryKeys } from 'core/api/queryKeys';
import { useI18n } from 'core/i18n/I18nProvider';

export function useProfileOptions({ enabled = true } = {}) {
  const { locale } = useI18n();
  return useQuery({
    queryKey: queryKeys.profileOptions(locale),
    queryFn: ({ signal }) => authApi.profileOptions({ signal }),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
